module.exports = __webpack_public_path__ + "img/hide-noDate-tasks.81d202a5.svg";